import LoadingModal from '@components/atoms/modals/LoadingModal';
import { AnalyticsScreenName } from 'mh-client';
import { lazy, Suspense } from 'react';
import { Route } from 'react-router';
import ProtectedRoute from './components/ProtectedRoute';

const Names = AnalyticsScreenName.getInstance();
const BuyShareOrder = lazy(
    () => import('@pages/transactions/buy/BuyShareOrder')
);
const BuyShareCompleteTransfer = lazy(
    () => import('@pages/transactions/buy/BuyShareCompleteTransfer')
);
const BuyShareConfirm = lazy(
    () => import('@pages/transactions/buy/BuyShareConfirm')
);
const BuySharePending = lazy(
    () => import('@pages/transactions/buy/BuySharePending')
);
const SellShareOrder = lazy(
    () => import('@pages/transactions/sell/SellShareOrder')
);
const SellShareConfirm = lazy(
    () => import('@pages/transactions/sell/SellShareConfirm')
);
const SellSharePending = lazy(
    () => import('@pages/transactions/sell/SellSharePending')
);

export const TransactionRoutes = (
    <>
        <Route
            path="/funds/:ticker/investment/buy"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <BuyShareOrder />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.RESERVE_SHARES_1 }}
        />
        <Route
            path="/funds/:ticker/investment/buy/confirm"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <BuyShareConfirm />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.RESERVE_SHARES_2 }}
        />
        <Route
            path="/funds/:ticker/investment/buy/bank-transfer"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <BuyShareCompleteTransfer />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.RESERVE_SHARES_3 }}
        />

        <Route
            path="/funds/:ticker/investment/buy/pending"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <BuySharePending />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.RESERVE_SHARES_PENDING }}
        />
        <Route
            path="/funds/:ticker/investment/sell"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <SellShareOrder />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.SELL_SHARES }}
        />
        <Route
            path="/funds/:ticker/investment/sell/confirm"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <SellShareConfirm />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.SELL_SHARES_REVIEW }}
        />
        <Route
            path="/funds/:ticker/investment/sell/pending"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <SellSharePending />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.SELL_ORDER_REVIEW }}
        />
    </>
);
